<div class="matrix-table-block">
  <div class="question-block">
    <div class="block-layer"></div>
    <div class="question-wrapper-matrix horizontal-view-truefalse">
      <ng-component class="editor-question1"
                [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
      <div class="question-type-table">
        <table class="metrix-table ">
          <tr>
            <th>

            </th>
            <th class="options">
              <div class="editor text-center aling-txt" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
                <ng-component [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
              </div>
            </th>
          </tr>
          <tr *ngFor="let stem of questions?.stems, let i = index">
            <td>
              <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(stem?.stemdescription.description)"></ng-component>
            </td>
            <td class="options">
              <div class="text-center1" *ngFor="let o of questions?.options | orderBy: 'arrangeOrderForStems'">
                <mat-radio-group name='{{i}}' fxLayout="column" class="matrix-radio">
                  <mat-radio-button class="question-mat-radio" [checked]="o.optionId===stem.validchoiceid" [disabled]='isReadOnly' [value]="o.optionId">
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
